// #region Global Imports
import * as React from 'react';
import dynamic from 'next/dynamic';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import { getFragmentData } from '@generated/fragment-masking';
import type { IProps } from '@components/Paragraphs/Paragraph/Paragraph';
import styles from './Paragraph.module.sass';
// #endregion Local Imports

export const ParagraphFragment = gql(/* GraphQL */ `
  fragment ParagraphFragment on Entity {
    uuid: entityUuid
    translation: entityTranslation(language: $language) {
      __typename
      ...ParagraphTitleFragment
      ...ParagraphTextFragment
      ...ParagraphTeaserTextFragment
      ...ParagraphInfoBoxFragment
      ...ParagraphFootnotesFragment
      ...ParagraphQuoteFragment
      ...ParagraphSmallTextFragment
      ...ParagraphFileFragment
      ...ParagraphMediaFragment
    }
  }
`);

const ParagraphTypes: Record<string, any> = {
  ParagraphFile: dynamic(() =>
    import('../ParagraphFile').then((mod) => mod.ParagraphFile),
  ),
  ParagraphFootnotes: dynamic(() =>
    import('../ParagraphFootnotes').then((mod) => mod.ParagraphFootnotes),
  ),
  ParagraphInfoBox: dynamic(() =>
    import('../ParagraphInfoBox').then((mod) => mod.ParagraphInfoBox),
  ),
  ParagraphQuote: dynamic(() =>
    import('../ParagraphQuote').then((mod) => mod.ParagraphQuote),
  ),
  ParagraphSmallText: dynamic(() =>
    import('../ParagraphSmallText').then((mod) => mod.ParagraphSmallText),
  ),

  // TODO: Insert some sort of exception

  ParagraphText: dynamic(() =>
    import('../ParagraphText').then((mod) => mod.ParagraphText),
  ),
  ParagraphTitle: dynamic(() =>
    import('../ParagraphTitle').then((mod) => mod.ParagraphTitle),
  ),
  ParagraphMedia: dynamic(() =>
    import('../ParagraphMedia').then((mod) => mod.ParagraphMedia),
  ),
};

export const Paragraph: React.FunctionComponent<IProps.Paragraph> = ({
  paragraph: _paragraph,
}) => {
  const paragraph = getFragmentData(ParagraphFragment, _paragraph);
  const DynamicParagraph: React.FunctionComponent<{ paragraph: unknown }> =
    ParagraphTypes[String(paragraph.translation?.__typename)]!;

  return (
    <div className={styles.Paragraph__root} id={String(paragraph.uuid)}>
      {DynamicParagraph && (
        <DynamicParagraph paragraph={paragraph.translation} />
      )}
    </div>
  );
};
